import { render, staticRenderFns } from "./NoticeMngtDtl.vue?vue&type=template&id=ef56569a"
import script from "./NoticeMngtDtl.vue?vue&type=script&lang=js"
export * from "./NoticeMngtDtl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports